<div class="dialog-container">
  @if (data.editPatientTitle) {
    <h3 mat-dialog-title>Edit {{ editSubjectLabel }}</h3>
  } @else if (!data.contact.isPatient) {
    <h3 mat-dialog-title>{{ label }} Callback Location</h3>
  } @else {
    <h3 mat-dialog-title>{{ label }} Contact Information</h3>
  }
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ data.contact.isPatient ? 'Name' : 'Title' }}</mat-label>
        <input
          matInput
          type="text"
          [formControl]="name"
          [placeholder]="data.contact.isPatient ? 'e.g., John Doe' : 'e.g., DataFinn Main Office'"
          [attr.aria-label]="data.contact.isPatient ? 'contact name' : 'callback location title'"
          [disabled]="readOnlyEdit"
          required
        />
        @if (name.invalid) {
          <mat-error>{{ getNameErrorMessage() }}</mat-error>
        }
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>Phone Number</mat-label>
        <input
          matInput
          type="text"
          [formControl]="contactNumber"
          placeholder="e.g., (530) 334-5540"
          aria-label="emergency contact number"
          (keyup)="handleKeyUp($event)"
          [disabled]="readOnlyEdit"
          [required]="!data.editPatientTitle"
        />
        @if (contactNumber.invalid) {
          <mat-error>
            {{ getContactNumberErrorMessage() }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    @if (showEditPatientDefaultLocation) {
      <div>
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Callback location</mat-label>
          <mat-select [formControl]="defaultLocationIdControl" placeholder="Select a callback location" required>
            @for (loc of data.callbackLocations; track loc.id) {
              <mat-option [value]="loc.id">{{ loc.name }}</mat-option>
            }
          </mat-select>
          @if (defaultLocationIdControl.hasError('required')) {
            <mat-error>Select a callback location</mat-error>
          }
        </mat-form-field>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button (click)="closeDialog()">Discard</button>
    <button
      mat-raised-button
      color="primary"
      (click)="saveDialog()"
      cdkFocusInitial
      [disabled]="readOnlyEdit || saveDisabled"
    >
      SAVE
    </button>
  </mat-dialog-actions>
</div>
